module.exports = __webpack_public_path__ + "img/4.f42f6690.png";